import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { CurrencyData } from '../../_models/currency';
import { Counts } from '../../_models/data';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { NotificationService } from '../../_services/notification.service';
import { DocTypeData } from '../../_models/document.type';
import { transition } from '@angular/animations';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrl: './document.component.css'
})
export class DocumentTypeComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  
  // userData: UserData;
  page: number = 1;
  count: Counts;

  url = this.router.url.slice(1);

  mainHeader: string = "List All Doc. Type";
  formHeader: string = "Add New Doc. Type";
  view: string = "";

  processing: boolean = false;
  loading: boolean = true;
  buttonText: string = "Add New Doc. Type";

  documentTypeList: DocTypeData[] = [];
  currencyList: CurrencyData[] = [];

  edit: boolean = false;
  docTypeName: string = '';
  docTypeRef: number = 0;

  documentAssociation = [
    {
      name: 'None',
      class: 'none'
    },
    {
      name: 'Bank Account Details',
      class: 'UserBankAccount'
    },
    {
      name: 'Compliance Details',
      class: 'UserCompliance'
    },
    {
      name: 'Contact Details',
      class: 'UserContact'
    },
    {
      name: 'Director and Sec Details',
      class: 'UserDirector'
    },
    {
      name: 'International Branches Details',
      class: 'UserInternationalB'
    },
    {
      name: 'Local Branches Details',
      class: 'UserLocalBranch'
    },
    {
      name: 'Owner Details',
      class: 'UserOwner'
    },
    {
      name: 'Related Entity',
      class: 'UserRelatedEntity'
    },
    {
      name: 'Transition Details',
      class: 'UserTransactionDetails'
    }
  ]

  dataForm = this.fb.group({
    ref: [0],
    title: ["", Validators.required],
    association: ["", Validators.required],
    scope: ["", Validators.required],
    notes: ['', Validators.maxLength(1000)]
  }, {});
  
  get ref() { return this.dataForm.get('ref'); }
  get title() { return this.dataForm.get('title'); }
  get association() { return this.dataForm.get('association'); }
  get scope() { return this.dataForm.get('scope'); }
  get notes() { return this.dataForm.get('notes'); }

  constructor(
    private fb: FormBuilder,
    public checkService: ChecksService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.checkService.checkSession();
    this.getRouteParams();
  }

  ngOnInit(): void {

    if (this.routeParams['view'] !== undefined) {
      this.view = this.routeParams['view'];
      this.mainHeader = "List "+this.view+" Doc. Types";
    }

    if (this.queryParams['page'] !== undefined) {
      this.page = this.queryParams['page'];
    } else {
      this.page = 1;
    }
    this.getDocType(this.page);
  }

  getDocType(page:number) {
    this.loading = true;

    this.apiService.getDocType(page, this.view).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.count = data.counts;
          this.documentTypeList = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );

  }

  onCreate() {
    var data: object = {
      title: this.dataForm.value.title,
      association: this.dataForm.value.association,
      scope: this.dataForm.value.scope,
      notes: this.dataForm.value.notes,
    };
    if (this.edit === true) {
      data['ref'] = this.dataForm.value.ref;
      this.editDocType(data);
    } else {
      data['online'] = 0;
      this.createDocType(data);
    }
  }

  createDocType( data ) {
    this.processing = true;

    this.buttonText = "Adding New Doc. Type...";
    this.apiService.createDocType(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Created "+data.title+" as a Doc. Type", "Doc. Type Created");
          this.checkService.closeModal('modal-document-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Doc. Type";
      }
    );
  }

  editDocType( data ) {
    this.processing = true;

    this.buttonText = "Saving Changes...";
    this.apiService.editDocType(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("saved changes made to Doc. Type", "Doc. Type Edited");
          this.checkService.closeModal('modal-document-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Doc. Type";
        this.edit = false;
      }
    );
  }

  getEdit(data:DocTypeData) {
    this.dataForm.patchValue({
      ref: data.ref,
      title: data.title,
      association: data.association,
      scope: data.scope,
      notes: data.notes
    });
    this.edit = true;
    this.formHeader = "Edit "+data.title;
    this.buttonText = "Edit Doc. Type";
  }

  onCancel() {
    this.edit = false;
    this.dataForm.reset();
    this.formHeader = this.buttonText = "Add New Doc. Type";
  }
  
  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });

    // URL get change
    this.activatedRoute.url.subscribe(url =>{
      this.ngOnInit();
    });
  }

  changeDocTypeStatus(action:string, ref:number) {
    let data:Object = {
      ref: ref,
      status: action.toLowerCase()
    }

    this.processing = true;

    this.apiService.changeDocTypeStatus(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Changes made to Doc. Type successfully", "Doc. Type Modified");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  deleteDocType(ref:number) {
    this.processing = true;

    this.apiService.deleteDocType(ref).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Doc. Type Removed Successfully", "Doc. Type Deleted");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-online').click();
        document.getElementById('modal-offline').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  getDataFromList(name:string, ref:number) {
    this.docTypeName = name;
    this.docTypeRef = ref;
  }

  findInObject(className: string) {
    const match = this.documentAssociation.find(item => item.class === className);
    return match ? match.name : "None"; 
  }
}
